
export const AgreementExpiryValidation = (formData) => {
    const errors = {};
    debugger;
    if (!formData.NextCheckDate) {
        errors.NextCheckDate = 'This field is required';
    }
    if (!formData.CheckFrequency || formData.CheckFrequency=="0") {
        errors.CheckFrequency = 'This field is required';
    }
    if (!formData.dt_NotifyExpiry) {
        errors.dt_NotifyExpiry = 'This field is required';
    }
     return errors;
};
